import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { ListMusic, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Playlists() {
  const { user, ready } = useAuth();
  const nav = useNavigate();
  const [mine, setMine] = useState([]);
  const [pub, setPub] = useState([]);
  const [name, setName] = useState("");
  const [isPublic, setIsPublic] = useState(true);

  const reload = () => {
    if (user) api.get(`/playlists?user_id=${user.id}`).then(r=>setMine(r.data));
    api.get("/playlists").then(r=>setPub(r.data));
  };
  useEffect(() => { reload(); }, [user]);

  if (ready && !user) { nav("/login"); return null; }

  const create = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try { await api.post("/playlists", { name, is_public: isPublic }); setName(""); reload(); toast.success("Playlist created"); }
    catch(e){toast.error(apiErr(e));}
  };
  const del = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/playlists/${id}`); reload(); };

  return (
    <div className="mx-auto max-w-5xl px-4 sm:px-6 pt-6">
      <h1 className="h-font text-3xl font-bold flex items-center gap-2"><ListMusic size={22}/> Playlists</h1>

      <form onSubmit={create} className="mt-6 flex gap-2 flex-wrap" data-testid="create-playlist-form">
        <input value={name} onChange={e=>setName(e.target.value)} placeholder="New playlist name" data-testid="playlist-name"
               className="flex-1 min-w-[200px] h-11 rounded-xl bg-white/5 border border-white/10 px-4 focus:outline-none focus:border-[#08D9D6]"/>
        <label className="flex items-center gap-2 text-sm px-3">
          <input type="checkbox" checked={isPublic} onChange={e=>setIsPublic(e.target.checked)} className="w-4 h-4 accent-[#08D9D6]"/>
          Public
        </label>
        <button data-testid="playlist-create-btn" className="jx-btn h-11 px-4 rounded-xl bg-[#08D9D6] text-black font-bold inline-flex items-center gap-2"><Plus size={14}/> Create</button>
      </form>

      <h2 className="h-font text-xl font-bold mt-8">Your playlists</h2>
      <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {mine.length===0 && <div className="text-sm text-white/50">Nothing yet.</div>}
        {mine.map(p=>(
          <div key={p.id} className="rounded-2xl border border-white/10 bg-white/5 p-4">
            <div className="flex items-start justify-between">
              <Link to={`/playlists/${p.id}`} className="font-bold">{p.name}</Link>
              <button onClick={()=>del(p.id)} className="p-2 text-white/50 hover:text-[#FF2E63]"><Trash2 size={14}/></button>
            </div>
            <div className="text-xs text-white/50 mt-1">{p.count} videos · {p.is_public?'Public':'Private'}</div>
          </div>
        ))}
      </div>

      <h2 className="h-font text-xl font-bold mt-10">Public playlists</h2>
      <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {pub.map(p=>(
          <Link key={p.id} to={`/playlists/${p.id}`} className="rounded-2xl border border-white/10 bg-white/5 p-4 hover:bg-white/10">
            <div className="font-bold">{p.name}</div>
            <div className="text-xs text-white/50 mt-1">by @{p.username} · {p.count} videos</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
